// extracted by mini-css-extract-plugin
export default {"rating":"YO-z","numberOfStars":"ZO-z","count":"_O-z","barGraphSpacing":"aP-z","barGraph":"bP-z"};